import { educationLevelTypes } from "utils/helpers/dictionaries";

export const educationLevelList: educationLevelTypes[] = [
  educationLevelTypes.undergraduate,
  educationLevelTypes.postgraduate,
]